<div class="ripple-container">
  @for (wave of waves; track wave; let i = $index) {
    <div
      class="ripple"
      [ngStyle]="{
        animationDuration: duration * waveCount + 'ms',
        animationDelay: (i * (duration / waveCount) + delay) + 'ms',
        backgroundColor: color,
        borderRadius: shape === 'circle' ? '50%' : borderRadius
      }"
    ></div>
  }
  <ng-content></ng-content> <!-- İçerik için slot -->
</div>